import { render, staticRenderFns } from "./RegistrationSimple.vue?vue&type=template&id=c4aaa466"
import script from "./RegistrationSimple.vue?vue&type=script&lang=js"
export * from "./RegistrationSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports